module.exports = __webpack_public_path__ + "img/logo.8d4ac625.png";